import React from 'react';

const CountryConfigContext = React.createContext<
  Configuration | Record<string, never>
>({});

export default CountryConfigContext;
